import * as ActionTypes from './types.action';

export const setDriverInstruction = driverInstruction => ({
  type: ActionTypes.SET_DRIVER_INSTRUCTION_SUCCESS,
  driverInstruction,
});
